export default "__VITE_ASSET__n525L7f2__"